module.exports = __webpack_public_path__ + "img/pid-robot.3ae62605.svg";